import moment from "moment";
import { isArray, isDate } from "lodash";
import { GridFilterItem } from "@mui/x-data-grid-pro";
import { OperatorsMapper } from "./constans";

export const parseDataGridFilters = (filters: GridFilterItem[]) => {
  const defaultOperator = "=like=";

  return filters
    .reduce((filters, filter) => {
      const operator =
        OperatorsMapper[filter.operator as keyof typeof OperatorsMapper] ||
        defaultOperator;

      if (isDate(filter.value) && filter.value) {
        if (filter.operator === "is") {
          filters.push({
            field: filter.field,
            value: moment(filter.value).startOf("day").toISOString(true),
            operator: "=ge=",
          });
          filters.push({
            field: filter.field,
            value: moment(filter.value).endOf("day").toISOString(true),
            operator: "=le=",
          });
        } else if (["after", "onOrBefore"].includes(filter.operator)) {
          filters.push({
            field: filter.field,
            value: moment(filter.value).endOf("day").toISOString(true),
            operator,
          });
        } else if (["onOrAfter", "before"].includes(filter.operator)) {
          filters.push({
            field: filter.field,
            value: moment(filter.value).startOf("day").toISOString(true),
            operator,
          });
        } else {
          filters.push({
            field: filter.field,
            value: moment(filter.value).format("YYYY-MM-DD"),
            operator,
          });
        }
      } else if (isArray(filter.value)) {
        if (filter.value.length > 0) {
          filters.push({
            field: filter.field,
            value:
              filter.operator === "isAnyOf"
                ? `(${filter.value})`
                : `"${filter.value}"`,
            operator,
          });
        }
      } else if (filter.value != null) {
        filters.push({
          field: filter.field,
          value:
            filter.operator === "isAnyOf"
              ? `(${filter.value})`
              : `"${filter.value}"`,
          operator,
        });
      }
      return filters;
    }, [] as { field: string; value: string; operator: string }[])
    .map(({ field, value, operator }) => `${field}${operator}${value}`)
    .join(";");
};
